import { render, staticRenderFns } from "./SmsTemplateEditor.vue?vue&type=template&id=5760379f&scoped=true"
import script from "./SmsTemplateEditor.vue?vue&type=script&lang=js"
export * from "./SmsTemplateEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5760379f",
  null
  
)

export default component.exports